export default __webpack_public_path__ + "static/media/Metal-Craft.f324f843.jpg";